export default paramsObject => {
  const paramsKeys = Object.keys(paramsObject).filter(
    key => (paramsObject[key] !== 0 && Boolean(paramsObject[key])) || 0
  );
  return paramsKeys.map(key => `${key}=${paramsObject[key]}`).join('&');
}
